export default __webpack_public_path__ + "static/media/notificacao_teste.d98738f2.mp3";